import OpportunityProcess from "./OpportunityProcess";

export default OpportunityProcess;
